import { Question } from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";

export default function MissingReleaseNumberTooltip() {
  return (
    <TooltipProvider showTimeout={0}>
      <TooltipAnchor>
        <Question />
      </TooltipAnchor>
      <Tooltip className="w-48 text-center text-r8-xs">
        <TooltipArrow />
        We didn't record the release number for this setup run.
      </Tooltip>
    </TooltipProvider>
  );
}
